/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * CustomerHeader.tsx — Custome\1 \2eader (services/operator-web-app).
 */

import { useWorkspace } from '@/store';
import { Button, Panel } from '@/components/ui';
import { HighlightBox } from '@/features/copilot';
import { useTranslation } from '@/i18n';

/**
 * L1 — Customer header and identity block. Plan: 05_client_card_workspace, 14 wireframes.
 * ФИО/Компания, телефон, ID клиента (copy), сегмент, сценарий.
 */
export function CustomerHeader() {
  const t = useTranslation();
  const workspace = useWorkspace();
  const card = workspace.customerCard;
  const customerId = workspace.customerId;

  const copyClientId = () => {
    const id = card?.clientId ?? customerId ?? '';
    if (id && typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(id);
    }
  };

  if (!card && !customerId) {
    return (
      <HighlightBox widgetId="customer_card_header">
        <Panel title={t('customer.title')} padding="md">
          <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
            {t('customer.waiting')}
          </p>
        </Panel>
      </HighlightBox>
    );
  }

  const name = card?.name ?? '—';
  const company = card?.company ?? '—';
  const phone = card?.phone ?? '—';
  const clientId = card?.clientId ?? customerId ?? '—';
  const segment = card?.segment ?? '—';
  const scenario = card?.scenario ?? '—';

  return (
    <HighlightBox widgetId="customer_card_header">
      <Panel
        title={t('customer.title')}
        padding="md"
        actions={
          clientId !== '—' ? (
            <Button
              variant="ghost"
              size="sm"
              onClick={copyClientId}
              aria-label={t('customer.copy_id')}
            >
              {t('customer.copy_id')}
            </Button>
          ) : undefined
        }
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 text-sm">
          <div>
            <span style={{ color: 'var(--text-muted)' }}>{t('customer.name_company')}</span>
            <p className="font-medium truncate" style={{ color: 'var(--text-primary)' }}>
              {name}
              {company !== '—' && ` · ${company}`}
            </p>
          </div>
          <div>
            <span style={{ color: 'var(--text-muted)' }}>{t('customer.phone')}</span>
            <p className="font-medium" style={{ color: 'var(--text-primary)' }}>
              {phone}
            </p>
          </div>
          <div>
            <span style={{ color: 'var(--text-muted)' }}>{t('customer.id')}</span>
            <p className="font-mono truncate" style={{ color: 'var(--text-primary)' }}>
              {clientId}
            </p>
          </div>
          <div>
            <span style={{ color: 'var(--text-muted)' }}>{t('customer.segment_scenario')}</span>
            <p style={{ color: 'var(--text-primary)' }}>
              {segment} · {scenario}
            </p>
          </div>
        </div>
      </Panel>
    </HighlightBox>
  );
}
